import { render, staticRenderFns } from "./GoImage.vue?vue&type=template&id=394d390b&scoped=true"
import script from "./GoImage.vue?vue&type=script&lang=js"
export * from "./GoImage.vue?vue&type=script&lang=js"
import style0 from "./GoImage.vue?vue&type=style&index=0&id=394d390b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d390b",
  null
  
)

export default component.exports